document.addEventListener('DOMContentLoaded', function () {

  function initMobileMenu() {
    const trigger = document.querySelector('.menu_moblie .menuleft');
    const closeBtn = document.querySelector('.close-menu-mobile');
    const menu = document.querySelector('.box_contentmenu');
    const menuBg = document.querySelector('.box_contentmenu_background');

    // Keep waiting until theme injects everything
    if (!trigger || !closeBtn || !menu || !menuBg) {
      return requestAnimationFrame(initMobileMenu);
    }

    console.log("Mobile menu ready. Binding forced menu events.");

    // Remove old href just in case
    trigger.removeAttribute('href');

    // --- OPEN/CLOSE TOGGLE (hamburger) ---
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      menu.classList.toggle('active');
      menuBg.classList.toggle('active');
      console.log("Hamburger toggle fired.");
    });

    // --- CLOSE ONLY (close button) ---
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      menu.classList.remove('active');
      menuBg.classList.remove('active');
      console.log("Close button fired.");
    });
  }

  initMobileMenu();
});
